<template>
  <div class="tva-row video-mostro-container">
    <div class="tva-col-md-8">
      <video id="video-anteprima" width="100%" height="auto">
        <source :src="'/'+content.source" type="video/mp4">
      </video>
      <div v-if="overlayShown" class="overlay">
        <div class="btn-play-trailer" @click="playVideo">Guarda il<br/>video trailer</div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
export default {
  props: ["content"],
  data() {
    return {
      video: null,
      overlayShown: true
    };
  },
  mounted() {
    this.video = document.getElementById("video-anteprima")
    this.video.onplaying = this.videoPlaying
    this.video.onpause = this.videoPaused
  },
  methods: {
    playVideo(){
      this.video.play()
    },
    videoPlaying(){
      this.overlayShown = false
      this.video.controls = true
    },
    videoPaused(){
      this.overlayShown = true
      this.video.controls = false
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.video-mostro-container{
  display: flex;
  justify-content: center;
  .overlay{
    position: absolute;
    top: 0px;
    width: 100%;
    height: 99%;
    background-color: rgba($mdf-darkblue, .8);
    z-index: 10;
    .btn-play-trailer{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      @include mdf-cta-text;
      cursor: pointer;
    }
  }
}
</style>
